// src/pages/Home.js
import React, { useState } from 'react';
import Hero from '../components/Hero';
import SearchBar from '../components/SearchBar';
import Trending from '../components/Trending';

export default function Home() {
    const [query, setQuery] = useState('');
    const handleSearch = () => console.log('Search for:', query);

    return (
        <div>
            <Hero />
            <SearchBar
                value={query}
                onChange={e => setQuery(e.target.value)}
                onSearch={handleSearch}
            />
            <Trending />
        </div>
    );
}
